import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.stAdministrators = new SmartTable();
        this.stDirectories = new SmartTable();

        this.administrators = this.cmpDetail.administrators;
        this.directories = this.cmpDetail.directories;
        this.domains = this.cmpDetail.domains;
        this.company = this.cmp.company;
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/details/company-details.controller.js